
import { Component, Vue } from 'vue-property-decorator'
import PublicTable from '@/components/PublicTable/PublicTable.vue'
import PublicTableView from '@/components/PublicTable/PublicTableView'
import { ICol } from '@/components/PublicTable/PublicTable'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
import CreateDepartment from '@/components/Dialog/CreateDepartment.vue'
import DisplayImage from '@/components/Dialog/DisplayImage.vue'
import { type } from 'os'
import { log } from 'console'
import { Row } from 'element-ui'
@Component({
  components: {
    PublicTable,
    CreateDepartment,
    DisplayImage,
  },
})
export default class DepartmentList extends PublicTableView {
  protected columns: ICol[] = [
    { label: '部门', prop: 'deptName' },
    { label: '已添加网络', prop: 'netName', type: 'custom' },
  ]
  protected queryParams = {
    orgId: UserModule.orgInfo.orgId,
  }
  private data1:any[]=[]
  private value1:any[]=[]
  private filterMethod(query: string, item: any) {
    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
  }
  public mounted() {
    this.onQuery(1)
  }
  protected queryMethod = api.getDepartmentList

  protected processData(data: any) {
    const { deptList = [] } = data || {}
    return deptList
  }

  private createDepartment() {
    (this.$refs.createDepartment as CreateDepartment).show()
  }
  private upddata(item){
    console.log(item)
    if(this.desc!=''){
      this.desc= this.desc.replace(/[ ]|[\r\n]/g,"");
      console.log(this.desc);
      let data={
        qrcodeId:item.qrcodeId,
        code:this.desc
      }
      api.updData(data).then(res=>{
        console.log(res);
        if(res.success){
          this.$message('成功')
        }
        this.vis=false
        
      })
      

    }else{
      this.$message('内容不能为空')
    }
    
  }
  private setsz(id) {
    id += ''
    return id.substring(0, 1) == '0'
  }
  private vis=false
private nowitem={
  deptName:''
}
private desc=''
  private modifyDepartment(row: any,netlist:any[]) {
    (this.$refs.createDepartment as CreateDepartment).show(row)
  }
  private visbm=false
  private modifyDepartmentbm(row: any) {
    this.nowitem=row
    this.visbm=true
    //解决数组变字符串问题
    console.log(row)
    let list=[]
    list=row.userList
    // console.log(list);
    // //判断是否是数组
    // if(list.length>0){
    //   console.log(123);
      
    // }
    
    // list=["11","22"]
    
  
    this.value1=list
  }
  private upddatabm(item){
    console.log(item)
    console.log(this.data1);
    if(this.data1.length==0){

      return
    }
    
    api.OrgDeptAdmin({qrCodeId:item.qrcodeId,userList:this.data1}).then(res=>{
      console.log(res);
      this.$message.success('设置成功')

      this.visbm=false
      this.onQuery({ isUseCache: false })
      
    })
    
    
  }
   private modifyDepartmentmsp(row: any) {
    // (this.$refs.createDepartment as CreateDepartment).show(row)
    this.nowitem=row
    api.getdata({qrcodeId:row.qrcodeId}).then(res=>{
      console.log(res)
      this.desc=res
    this.vis=true

   
    })
  }
  private QRDepartment(row: any,codeType:string) {
    // if (row.qrcodeUrl) {
    //   (this.$refs.displayImage as DisplayImage).show(row.qrcodeUrl)
    // } else {
      console.log(row.qrcodeId.substring(0,1));
      
    this.showLoading()
    let type =row.qrcodeId.substring(0,1)=='0'?1:0
    let isV3=codeType=='v2'?false:true
    if(!type){
 api.generateQRcode({ qrcodeName: row.deptName, orgId: UserModule.orgInfo.orgId, deptId: row.deptId, type: type,isV3:isV3 }).then((data) => {
      (this.$refs.displayImage as DisplayImage).show(data.qrcodeUrl)
    }).finally(() => {
      this.closeLoading()
    })
    }else{
       api.generateQRcode2({ qrcodeName: row.deptName, orgId: UserModule.orgInfo.orgId, deptId: row.deptId, type: type,isV3:isV3  }).then((data) => {
      (this.$refs.displayImage as DisplayImage).show(data.qrcodeUrl)
    }).finally(() => {
      this.closeLoading()
    })
    }
   

    // }
  }
  private deleteDepartment(row: any) {
    this.$confirm('删除此部门, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      api.deleteDepartment(row.deptId).then(() => {
        this.$message.success('删除部门成功')
        this.onQuery({ isUseCache: false })
      })
    }).catch(() => {})
  }
}
